import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Ali Hossain',
    title: "Front-End Web Developer",
    desciption: "“Any fool can write code that a computer can understand. Good programmers write code that humans can understand.” – Martin Fowler ",
    image: 'https://raw.githubusercontent.com/AliHossain01/high-bikes/main/ali3.png',
    resumePdf: resume
}
